export const POPOVER_CLASS_NAME = 'coupdoeil--popover'
export const POPOVER_SELECTOR = `.${POPOVER_CLASS_NAME}`
export const POPOVER_CLOSE_BTN_SELECTOR = '[data-popover-close]'

// the time (ms) to wait before closing the popover,
// to avoid flickering if the user hovers out and in quickly,
// or if the user moves the mouse from the target to the popover
export const CLOSING_DELAY_MS = 100

// the time (ms) to wait before starting to fetch the content,
// to avoid fetching too soon if the user hovers in and out the target quickly
export const FETCH_DELAY_MS = 100

// the minimum time (ms) the user should wait before seeing the popover
export const OPENING_DELAY_MS = 200
